/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Video from 'components/Video/Video';
import Statement from '../Statement/Statement';
import './ProfileVideo.scss';

/**
 * This is the ProfileVideo component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function ProfileVideo({ layout, intro, ...props }) {
  return (
    <div className={`block profile-video layout-${layout}`}>
      <div className="video-container" appear="true">
        <Video {...props} />
      </div>
      <Statement limit={30}>{intro}</Statement>
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
ProfileVideo.propTypes = {
  layout: PropTypes.string,
  intro: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
ProfileVideo.defaultProps = {
  layout: 'left',
  intro: '',
};

export default ProfileVideo;
